var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#151F57"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 11.25C14.697 11.25 13.75 12.2074 13.75 13.2591C13.75 13.6734 13.4142 14.0091 13 14.0091C12.5858 14.0091 12.25 13.6734 12.25 13.2591C12.25 11.2632 13.9893 9.75 16 9.75C18.0107 9.75 19.75 11.2632 19.75 13.2591C19.75 14.645 18.7505 15.7345 17.6382 16.2931C17.0545 16.5862 16.75 17.0106 16.75 17.3671V18.5C16.75 18.9142 16.4142 19.25 16 19.25C15.5858 19.25 15.25 18.9142 15.25 18.5V17.3671C15.25 16.1772 16.1668 15.3535 16.965 14.9526C17.7766 14.5451 18.25 13.8789 18.25 13.2591C18.25 12.2074 17.303 11.25 16 11.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20.5C16.4142 20.5 16.75 20.8358 16.75 21.25V21.75C16.75 22.1642 16.4142 22.5 16 22.5C15.5858 22.5 15.25 22.1642 15.25 21.75V21.25C15.25 20.8358 15.5858 20.5 16 20.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6C10.4772 6 6 10.4772 6 16C6 21.5228 10.4772 26 16 26C21.5228 26 26 21.5228 26 16C26 10.4772 21.5228 6 16 6ZM7.46341 16C7.46341 11.2854 11.2854 7.46341 16 7.46341C20.7146 7.46341 24.5366 11.2854 24.5366 16C24.5366 20.7146 20.7146 24.5366 16 24.5366C11.2854 24.5366 7.46341 20.7146 7.46341 16Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertInfo);
export default __webpack_public_path__ + "static/media/alert_info.e50d77574dbbdad490e4909e8398e621.svg";
export { ForwardRef as ReactComponent };